import {
  InternalAdTrackingData,
  InternalAdTrackingDataParams,
} from "@shared/services/event_tracking/entities/ads/internal_ad_tracking_data";

interface MiniStoryAdEntityParams extends InternalAdTrackingDataParams {
  image_upload_url: string;
  product_line_ids: number[];
}

export class MiniStoriesContentCardAdEntity extends InternalAdTrackingData {
  placement_image_url: string;
  product_line_ids: number[];

  constructor(params: MiniStoryAdEntityParams) {
    super(params);
    this.type = "mini_stories_content_card_ad";
    this.entity_version = 2;
    this.placement_image_url = params.image_upload_url;
    this.product_line_ids = params.product_line_ids;
  }
}
